// Let the document and its static artwork paint before initializing WebGL.
// This is progressive enhancement for every visitor, including slow devices.
const afterPaint = () => new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
// Give the artwork and font the connection first, especially on mobile. Once
// they're decoded, the animation can load without delaying the initial view.
await Promise.allSettled([
  document.querySelector('.life-fallback')?.decode(),
  document.fonts?.ready,
]);
await afterPaint();
const idle = globalThis.requestIdleCallback || (callback => setTimeout(callback, 0));
idle(() => {
  import('./main.js').catch(error => console.warn('The static sculpture remains available.', error));
  import('./name-life.js').catch(error => console.warn('The name remains available without its effect.', error));
}, { timeout: 1000 });
